import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ERROR } from '../../../store/types'
import { updateTerm } from '../../../store/actions/termsActions'
import TextField from '../../elements/form/TextField'
import DateField from '../../elements/form/DateField'
import moment from 'moment'
import ModalActionButton from '../../elements/ModalActionButton'
import { Switch } from '@headlessui/react'

const EditTerm = ({term, close}) => {
  const dispatch = useDispatch()
    const termSelector = useSelector(state => state.terms)
    const [termPayload, setTermPayload] = useState(term)
    const [validationErrors, setValidationErrors] = useState({})

    const validateForm = () => {
        let errors = {}
        if(!termPayload.name || termPayload.name === '') {
            errors.name = true
        }
        if(!termPayload.startDate || termPayload.startDate === '') {
            errors.startDate = true
        }
        if(!termPayload.endDate || termPayload.endDate === '') {
            errors.endDate = true
        }

        setValidationErrors(errors)

        return errors
    }

    const pushTerm = () => {
        try {
            if (Object.values(validateForm()).includes(true)) {
                dispatch({
                    type: ERROR,
                    error: {response: {data: {
                        message: 'Please check the highlighted fields'
                    }}}
                })
                return
            }

            dispatch(updateTerm(term._id, termPayload))

        } catch (error) {
            console.log(error)
            dispatch({
                type: ERROR,
                error
            })
        }
    }

    return (
        <div className='w-full'>
            <p className='text-sm text-gray-600'>Please change the details required and click on "Save Updates" to update the term.</p>

            <div className='mt-4'>
                <TextField
                    inputLabel="Term name/title" 
                    fieldId="term-name" 
                    inputType="text" 
                    requiredField={true}
                    inputPlaceholder={`Name the term`}
                    preloadValue={termPayload.name || ''}
                    hasError={validationErrors && validationErrors.name} 
                    returnFieldValue={(value)=>{setTermPayload({...termPayload, ...{name: value}})}}
                />
            </div>

            <div className='my-2'>
                <TextField
                    inputLabel="Description" 
                    fieldId="term-description" 
                    inputType="text" 
                    requiredField={false}
                    inputPlaceholder={`Short description for the term`}
                    preloadValue={termPayload.description || ''}
                    hasError={validationErrors && validationErrors.description} 
                    returnFieldValue={(value)=>{setTermPayload({...termPayload, ...{description: value}})}}
                />
            </div>

            <div className='my-2 w-full'>
                <DateField
                    inputLabel="Start Date" 
                    fieldId="start-date" 
                    requiredField={true}
                    inputType="text" 
                    preloadValue={(moment(termPayload.startDate).format('YYYY-MM-DD')) || ''}
                    hasError={validationErrors && validationErrors.startDate} 
                    returnFieldValue={(value)=>{
                        // const formattedDate = (moment(value, 'YYYY-MM-DD').format('DD-MM-YYYY'))
                        setTermPayload({...termPayload, ...{startDate: new Date(value)}})
                    }}
                />
            </div>

            <div className='my-2 w-full'>
                <DateField
                    inputLabel="End Date" 
                    fieldId="end-date" 
                    requiredField={true}
                    inputType="text" 
                    preloadValue={(moment(termPayload.endDate).format('YYYY-MM-DD')) || ''}
                    hasError={validationErrors && validationErrors.endDate} 
                    returnFieldValue={(value)=>{
                        // const formattedDate = (moment(value, 'YYYY-MM-DD').format('DD-MM-YYYY'))
                        setTermPayload({...termPayload, ...{endDate: new Date(value)}})
                    }}
                />
            </div>

            <div className="w-full flex justify-between gap-x-4 mt-6 border-secondary border-opacity-50">
                <div className='w-10/12'>
                    <h3 className="block text-sm text-gray-700 font-space-grotesk font-semibold">Final Term</h3>
                    <p className="text-xs leading-tight text-gray-500 font-sofia-pro">Flip this switch if this term is the final term of the academic session.</p>
                </div>
                <div className='w-2/12 flex flex-row-reverse pt-2'>
                    <Switch
                        checked={termPayload.finalTermOfSession}
                        onChange={()=>{setTermPayload({...termPayload, finalTermOfSession: !termPayload.finalTermOfSession})}}
                        className={`${
                            termPayload.finalTermOfSession ? 'bg-accent' : 'bg-gray-400'
                        } relative inline-flex items-center h-5 rounded-full w-10`}
                        >
                        <span className="sr-only">Requires fee</span>
                        <span
                            className={`transform transition ease-in-out duration-200 ${
                                termPayload.finalTermOfSession ? 'translate-x-6 bg-primary' : 'translate-x-1 bg-gray-600'
                            } inline-block w-3 h-3 transform rounded-full`}
                        />
                    </Switch>
                </div>
            </div>

            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Save updates`}
                    buttonAction={()=>{pushTerm()}}
                    processing={termSelector.creatingTerm}
                 />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={close}
                >
                    Cancel
                </button>
                
            </div>
        </div>
    )
}

export default EditTerm